<template>
  <!-- O COMPONENTE NÃO POSSUI VALIDAÇÕES (COMPRIMENTO E SEQUÊNCIA VÁLIDA) POIS ACEITA COMPRIMENTO PARCIAL -->
  <NxInput
    name="bairro"
    type="text"
    label="bairro:"
    placeholder="EX: Vila Ruiz"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputBairro',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputBairro.vue